import { Code2, Copy, Download } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shigo-ui/ui';

import { downloadBlob } from '../../../../../lib/downloadBlob';
import { dashboardT } from '../../../../../lib/messages';
import { copyToClipboard } from '../../../../../lib/clipboard';

export function PublisherImmuTagDialog({
  tag,
  onOpenChange,
}: {
  tag: string;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Code2 className="h-5 w-5" aria-hidden="true" />
            {dashboardT('publisherDetails.immuTag')}
          </DialogTitle>
          <DialogDescription>{dashboardT('publisherDetails.immuTagDescription')}</DialogDescription>
        </DialogHeader>
        <pre className="border-input bg-muted/30 max-h-[55vh] overflow-auto rounded-md border p-4 text-xs whitespace-pre-wrap">
          {tag}
        </pre>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              downloadBlob(
                new Blob([tag], { type: 'text/plain;charset=utf-8' }),
                `immu_tag_${new Date().toISOString().slice(0, 10)}.txt`,
              );
            }}
          >
            <Download className="h-4 w-4" aria-hidden="true" />
            {dashboardT('publisherDetails.downloadImmuTag')}
          </Button>
          <Button
            type="button"
            onClick={() => {
              void copyToClipboard(tag, {
                successMessage: dashboardT('publisherDetails.immuTagCopied'),
                errorMessage: dashboardT('publisherDetails.immuTagCopyError'),
              });
            }}
          >
            <Copy className="h-4 w-4" aria-hidden="true" />
            {dashboardT('publisherDetails.copyImmuTag')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
